import { defaultUnits, QuantitiesTypes } from 'common/enums/unit-templates.js';
import { KnowEdmTableValue } from '../interfaces.js';
import { KnowTableData } from './table-enums.js';

const trajectoryPlanMap = new Map<KnowTableData, KnowEdmTableValue<KnowTableData>>();

trajectoryPlanMap.set(KnowTableData.BuildMethod, {
  key: KnowTableData.BuildMethod,
  unit: '',
  label: 'Build Method',
  quantity: '',
});

trajectoryPlanMap.set(KnowTableData.DepthMd, {
  key: KnowTableData.DepthMd,
  label: 'MD',
  unit: defaultUnits.get(QuantitiesTypes.Depth),
  quantity: QuantitiesTypes.Depth,
});

trajectoryPlanMap.set(KnowTableData.CurveLength, {
  key: KnowTableData.CurveLength,
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Length,
  label: 'CL',
});

trajectoryPlanMap.set(KnowTableData.Inclination, {
  key: KnowTableData.Inclination,
  label: 'INC',
  unit: defaultUnits.get(QuantitiesTypes.Angle),
  quantity: QuantitiesTypes.Angle,
});

trajectoryPlanMap.set(KnowTableData.Azimuth, {
  key: KnowTableData.Azimuth,
  label: 'AZI',
  unit: defaultUnits.get(QuantitiesTypes.Angle),
  quantity: QuantitiesTypes.Angle,
});

trajectoryPlanMap.set(KnowTableData.DepthTvd, {
  key: KnowTableData.DepthTvd,
  unit: defaultUnits.get(QuantitiesTypes.Depth),
  quantity: QuantitiesTypes.Depth,
  label: 'TVD',
});

trajectoryPlanMap.set(KnowTableData.LocalPositionEW, {
  key: KnowTableData.LocalPositionEW,
  unit: '',
  label: 'EW',
  quantity: '',
});

trajectoryPlanMap.set(KnowTableData.LocalPositionNS, {
  key: KnowTableData.LocalPositionNS,
  unit: '',
  label: 'NS',
  quantity: '',
});

trajectoryPlanMap.set(KnowTableData.VerticalSection, {
  key: KnowTableData.VerticalSection,
  unit: '',
  label: 'Vertical Section',
  quantity: '',
});

trajectoryPlanMap.set(KnowTableData.Dogleg, {
  key: KnowTableData.Dogleg,
  label: 'DLS',
  unit: defaultUnits.get(QuantitiesTypes.AngleGradient),
  quantity: QuantitiesTypes.AngleGradient,
});

trajectoryPlanMap.set(KnowTableData.Toolface, {
  key: KnowTableData.Toolface,
  label: 'Toolface',
  unit: defaultUnits.get(QuantitiesTypes.Angle),
  quantity: QuantitiesTypes.Angle,
});

trajectoryPlanMap.set(KnowTableData.Build, {
  key: KnowTableData.Build,
  label: 'Build',
  unit: defaultUnits.get(QuantitiesTypes.AngleGradient),
  quantity: QuantitiesTypes.AngleGradient,
});

trajectoryPlanMap.set(KnowTableData.Turn, {
  key: KnowTableData.Turn,
  label: 'Turn',
  unit: defaultUnits.get(QuantitiesTypes.AngleGradient),
  quantity: QuantitiesTypes.AngleGradient,
});

export { trajectoryPlanMap };